import React from "react";
import { profileContactLogChatLogsData } from "../common/Helper";
import { useStateProvider } from "../common/StateProvider";
import AttachFileModal from "../common/AttachFileModal";
import { StoryBookIcon } from "../common/Icon";

const ProfileContactLogChatLogs = () => {
  const { profileAttachFileModal, setprofileAttachFileModal } =
    useStateProvider(); //ATTACH FILE MODAL

  // Function to show the Attach File MODAL
  const openMeetingAttachFileModal = () => {
    setprofileAttachFileModal(true);
  };
  return (
    <>
      <div className=" pb-[50px] h-full flex flex-col relative">
        <div>
          {profileContactLogChatLogsData.map((value, index) => (
            <div
              className="w-[600px] md:w-auto p-[16px_14px] rounded-md bg-[#F6F6F6] hover:shadow-workflow_item_card_shadow duration-300 mb-[10px]"
              key={index}>
              <div className="flex gap-[10px] ">
                <img
                  className="w-[30px] h-[30px]"
                  src={value.chatLogsImg}
                  alt="chatLogs-Img"
                />
                <div className=" w-full pt-1">
                  <div className=" flex justify-between">
                    <p className="text-[14px] 3xl:text-[16px] font-normal text-black">
                      {value.chatLogsName}
                    </p>
                    <div className=" flex items-center gap-2">
                      <button className="rounded-full border-[0.688px] border-solid border-[rgba(0,_0,_0,_0.10)] bg-white p-1 hover:bg-primary story-book-icon duration-200">
                        <StoryBookIcon />
                      </button>

                      <button
                        onClick={openMeetingAttachFileModal}
                        className="text-[10px] 3xl:text-[14px] font-medium text-primary rounded-[36px] border border-solid border-primary p-[4px_10px] hover:bg-primary hover:text-white hover:border-transparent duration-200">
                        + Attach File
                      </button>
                    </div>
                  </div>
                  <div>
                    <div className="flex gap-5 pt-3">
                      <p className="text-[10px] 3xl:text-[14px] font-normal text-gray">
                        <span className="text-xs 3xl:text-[16px]  font-medium text-black opacity-70 pr-2 ">
                          Date:
                        </span>
                        {value.chatLogsFullDate}
                      </p>
                      <p className="text-[10px] 3xl:text-[14px] font-normal text-gray">
                        <span className="text-xs 3xl:text-[16px] font-medium text-black opacity-70 pr-2 ">
                          Time:
                        </span>
                        {value.chatLogsTime}
                      </p>
                    </div>
                    <p className="text-[14px] font-normal text-black opacity-70 pt-3">
                      {value.chatLogsText}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="fixed top-[25%] right-0 md:right-[14%] lg:right-[11%] xl:right-[8%] z-[9999] 3xl:top-[33%] 3xl:right-[6%]">
          {profileAttachFileModal && (
            <AttachFileModal
              attachFileModal={profileAttachFileModal}
              setAttachFileModal={setprofileAttachFileModal}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ProfileContactLogChatLogs;
